<template>
  <v-navigation-drawer
    location="right"
    permanent
    v-model="getIsDrawerOpen"
    :width="400"
  >
  <v-toolbar density="compact">
    <!-- <v-toolbar-title v-if="getDrawerContent">{{getDrawerContent.chName}}</v-toolbar-title> -->
    <v-spacer></v-spacer>
      

      <v-btn size="small" icon @click="closeDrawer">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>


    <div v-if="getDrawerContent">
      <!-- {{ getDrawerContent }} -->
      <v-card>
        <v-card-title>
        <h3 class="wrap-text">{{ getDrawerContent.churchName }}</h3>
        <v-spacer></v-spacer>
      </v-card-title>
    </v-card>
          <v-table>   
            <tbody>
            <tr v-if="getDrawerContent.modernPlacename">
              <td class="left-justify font-weight-bold">Modern Placename</td>
              <td class="left-justify">{{ getDrawerContent.modernPlacename }}</td>
            </tr>
            

            <tr v-if="getDrawerContent.projectObjectId">
              <td class="left-justify font-weight-bold">Project Object ID</td>
              <td class="left-justify">{{ getDrawerContent.projectObjectId }}</td>
            </tr>

            <tr v-if="getDrawerContent.universalObjectId">
              <td class="left-justify font-weight-bold">Universal Object ID</td>
              <td class="left-justify">{{ getDrawerContent.universalObjectId }}</td>
            </tr>

            <tr v-if="getDrawerContent.population">
              <td class="left-justify font-weight-bold">Population</td>
              <td class="left-justify">{{ getDrawerContent.population }}</td>
            </tr>

            <tr v-if="getDrawerContent.modernDistrict">
              <td class="left-justify font-weight-bold">Modern District</td>
              <td class="left-justify">{{ getDrawerContent.modernDistrict }}</td>
            </tr>

            <tr v-if="getDrawerContent.modernState">
              <td class="left-justify font-weight-bold">Modern State</td>
              <td class="left-justify">{{ getDrawerContent.modernState }}</td>
            </tr>

            <tr v-if="getDrawerContent.modernCountry">
              <td class="left-justify font-weight-bold">Modern Country</td>
              <td class="left-justify">{{ getDrawerContent.modernCountry }}</td>
            </tr>

            <tr v-if="getDrawerContent.secularJurisdiction">
              <td class="left-justify font-weight-bold">Secular Jurisdiction</td>
              <td class="left-justify">{{ getDrawerContent.secularJurisdiction }}</td>
            </tr>

            <tr v-if="getDrawerContent.localReligiousReform">
              <td class="left-justify font-weight-bold">Local Religious Reform</td>
              <td class="left-justify">{{ getDrawerContent.localReligiousReform }}</td>
            </tr>

            <tr v-if="getDrawerContent.modernGemeinde">
              <td class="left-justify font-weight-bold">Modern Gemeinde</td>
              <td class="left-justify">{{ getDrawerContent.modernGemeinde }}</td>
            </tr>
            

            <tr v-if="getDrawerContent.bishop">
              <td class="left-justify font-weight-bold">Bishop</td>
              <td class="left-justify">{{ getDrawerContent.bishop }}</td>
            </tr>
            

            <tr v-if="getDrawerContent.archbishop">
              <td class="left-justify font-weight-bold">Archbishop</td>
              <td class="left-justify">{{ getDrawerContent.archbishop }}</td>
            </tr>
            

            <tr v-if="getDrawerContent.foundationDate">
              <td class="left-justify font-weight-bold">Foundation Date</td>
              <td class="left-justify">{{ getDrawerContent.foundationDate }}</td>
            </tr>
            

            <tr v-if="getDrawerContent.parishSaint">
              <td class="left-justify font-weight-bold">Parish Saint</td>
              <td class="left-justify">{{ getDrawerContent.parishSaint }}</td>
            </tr>
            

            <tr v-if="getDrawerContent.originalUsage">
              <td class="left-justify font-weight-bold">Original Usage</td>
              <td class="left-justify">{{ getDrawerContent.originalUsage }}</td>
            </tr>
            

            <tr v-if="getDrawerContent.churchImages">
              <td class="left-justify font-weight-bold">Church Images</td>
              <td class="left-justify">
                <a :href="getDrawerContent.churchImages" target="_blank">View Images</a>
              </td>
            </tr>
            

            <tr v-if="getDrawerContent.survivalOfSharedChurch">
              <td class="left-justify font-weight-bold">Survival of Shared Church</td>
              <td class="left-justify">{{ getDrawerContent.survivalOfSharedChurch }}</td>
            </tr>
            

            <tr v-if="getDrawerContent.historicalDescription">
              <td class="left-justify font-weight-bold">Historical Description</td>
              <td class="left-justify">{{ getDrawerContent.historicalDescription }}</td>
            </tr>
            

            <tr v-if="getDrawerContent.certaintyOfLocation">
              <td class="left-justify font-weight-bold">Certainty of Location</td>
              <td class="left-justify">{{ getDrawerContent.certaintyOfLocation }}</td>
            </tr>
            

            <tr v-if="getDrawerContent.coordinates">
              <td class="left-justify font-weight-bold">Coordinates</td>
              <td class="left-justify">{{ getDrawerContent.coordinates }}</td>
            </tr>
            

            <tr v-if="getDrawerContent.dateSharingStartedDeFacto">
              <td class="left-justify font-weight-bold">Date Sharing Started (De Facto)</td>
              <td class="left-justify">{{ getDrawerContent.dateSharingStartedDeFacto }}</td>
            </tr>
            

            <tr v-if="getDrawerContent.dateSharingEndedDeFacto">
              <td class="left-justify font-weight-bold">Date Sharing Ended (De Facto)</td>
              <td class="left-justify">{{ getDrawerContent.dateSharingEndedDeFacto }}</td>
            </tr>
            

            <tr v-if="getDrawerContent.catholics">
              <td class="left-justify font-weight-bold">Catholics</td>
              <td class="left-justify">{{ getDrawerContent.catholics }}</td>
            </tr>
            

            <tr v-if="getDrawerContent.protestants">
              <td class="left-justify font-weight-bold">Protestants</td>
              <td class="left-justify">{{ getDrawerContent.protestants }}</td>
            </tr>
            

            <tr v-if="getDrawerContent.nonCoreligiousMonastic">
              <td class="left-justify font-weight-bold">Non-Coreligious Monastic</td>
              <td class="left-justify">{{ getDrawerContent.nonCoreligiousMonastic }}</td>
            </tr>
            

            <tr v-if="getDrawerContent.reasonForEnd">
              <td class="left-justify font-weight-bold">Reason for End</td>
              <td class="left-justify">{{ getDrawerContent.reasonForEnd }}</td>
            </tr>
            

            <tr v-if="getDrawerContent.weblinks">
              <td class="left-justify font-weight-bold">Weblinks</td>
              <td class="left-justify">
                <a :href="getDrawerContent.weblinks" target="_blank">Related Links</a>
              </td>
            </tr>
            </tbody>
          </v-table>
        <!-- </v-card-text>
      </v-card> -->
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";

export default {
  data: () => ({
    drawer: true,
  }),
  computed: {
    ...mapState({
      isDrawerOpen: (state) => state.isDrawerOpen,
      drawerContent: (state) => state.drawerContent,
    }),

    ...mapGetters({
      getIsDrawerOpen: "getIsDrawerOpen",
      getDrawerContent: "getDrawerContent",
    }),
  },
  methods: {
    closeDrawer() {
      console.log("close drawer...!")
      this.$store.dispatch("closeDrawer");
      // ?store.dispatch('setIsDrawerOpen',drawerContent)

    },

    ...mapMutations(

    )
  },
};
</script>

<style scoped>
.left-justify font-weight-bold {
  font-weight: bold;
}

.bold-text {
  /* font-weight: bold; */
  text-align: left;
  vertical-align: top; /* Align text to the top of the cell */
}

.left-justify {
  text-align: left;
}

>>>.table-row {
  border-bottom: 1px solid #e0e0e0; /* Subtle border between rows */
}

>>>.table-row:last-child {
  border-bottom: none; /* Remove the border for the last row */
}

.wrap-text {
  white-space: normal; /* Allow the text to wrap */
  word-wrap: break-word; /* Break long words if necessary */
  overflow-wrap: break-word; /* Ensures wrapping for very long words */
  max-width: 100%; /* Ensure it stays within the available space */
}
</style>